// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__20MjF","nav":"style_nav__2zHPm","option":"style_option__2nXqK"};